import ErrorBox from 'ui/design-base/ErrorBox';
import Page from 'ui/design-base/Page';

const NotFoundPage = () => (
  <Page
    title='Pagina non trovata'
    description='Pagina 404 di errore pagina non trovata'
    className='flex items-center justify-center'
  >
    <ErrorBox
      errorMessage='La pagina cercata non è al momento disponibile oppure qualcosa è andato storto.'
      errorTitle='Problema nel caricamento della pagina profilo'
      errorType='ERROR 404'
    />
  </Page>
);

export default NotFoundPage;
